<div #applepayContainer></div>
@if (loading())
{
    <lib-frontend-spinner/>
}
@if(showError())
{
    <p>ApplePay wurde nicht gestartet. ApplePay läuft nur auf einem ApplePay kompatiblen Gerät mit Safarie.</p>
}
@if(showErrorInPaymentprocess())
{
    <p>Es gab einen Fehler beim Bezahlen. Versuchen Sie es erneut oder gehen Sie zurück und wählen eine andere Zahlungsmöglichkeit.</p>
}
<a class="btn" [href]="backUrl()">zurück</a>